module.exports = __webpack_public_path__ + "static/media/P200-sm-open.72b62395.svg";